import React from 'react';
import { RadioButton, RadioButtonGroup } from 'material-ui';
import RateTypeForm from '../RateType';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../../tc-ui/two-column-row.jsx';
import { currencies, taxTypes } from '../../../../../utils/select-fields';
import Select from 'react-select';
import StandardTemplate from './standard-template';
import MultiDayTour from './multi-day-tour';
import PrivateToursTransfers from './private-tour-transfers-template';
import PriceBreak from './price-break-template';

const NonAccomRates = ({
  definedRateTemplate,
  showTaxCurrency,
  updateFieldValue,
  updateFieldWithKeyPath,
  updateFormData,
  locationId,
  productId,
  ...fieldValues }) => {
  const leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px' };
  const rightColumnStyle = { width: '70%', textAlign: 'left', paddingRight: '30px' };
  const nonStandardTemplateType = fieldValues.nonStandardTemplateType || definedRateTemplate;
  const RatesFormTemplate = (() => {
    switch (nonStandardTemplateType) {
      case 'multiDayTour':
        return MultiDayTour;
      case 'privateTransfer':
        return PrivateToursTransfers;
      case 'priceBreak':
        return PriceBreak;
      case 'standard':
      default:
        return StandardTemplate;
    }
  })();
  return (
    <div style={{ margin: '3% 0 9% 0' }}>
      <TwoColumnRow
        outerContainerStyle={{ marginBottom: '0' }}
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        leftColumnContent={<div style={{ padding: '4px 0 4px 0' }}>
          Rates type
          <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
            * Required
          </div>
        </div>}
        rightColumnContent={
        <div style={{ padding: '4px 0 4px 0' }}>
          <RateTypeForm
            rateType={fieldValues.rateType}
            commissionPercentage={fieldValues.commissionPercentage}
            nettCommission={fieldValues.nettCommission}
            updateRateType={(value) => updateFormData({ fieldName: 'rateType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId)}
            updateCommission={(value) => updateFormData({ fieldName: 'commissionPercentage', value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId)}
            updateNettCommission={(value) => updateFormData({ fieldName: 'nettCommission', value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId)}
          />
        </div>
        }
      />
      <TwoColumnRow
        hide={!showTaxCurrency}
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflow: 'inherit', marginTop: '12px', marginBottom: '12px' }}
        leftColumnContent={
          <div>
            Tax information
            <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
              * Required
            </div>
          </div>
        }
        rightColumnContent={
          <div style={{ width: '300px' }}>
            <div style={{ width: '45%', display: 'inline-block' }}>
              <Select
                name="taxInclusion"
                options={[
                  { value: 'inclusive', label: 'Tax inclusive' },
                  { value: 'exclusive', label: 'Tax exclusive' },
                  { value: 'exempt', label: 'Tax exempt' },
                ]}
                value={fieldValues.taxInclusion}
                onChange={({ value }) => updateFormData({ fieldName: 'taxInclusion', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location')}
                placeholder="Tax Inclusion"
                clearable={false}
                scrollMenuIntoView={false}
              />
            </div>
            {
            fieldValues.taxInclusion !== 'exempt' ?
            <div style={{ width: '50%', marginLeft: '5%', display: 'inline-block' }}>
              <Select
                name="taxType"
                options={taxTypes}
                value={fieldValues.taxType}
                onChange={({ value }) => updateFormData({ fieldName: 'taxType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location')}
                placeholder="Tax Type"
                clearable={false}
                scrollMenuIntoView={false}
              />
            </div> : undefined
            }
          </div>
        }
      />
      <TwoColumnRow
        hide={!showTaxCurrency}
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflow: 'inherit', clear: 'both', height: '42px', marginBottom: '0' }}
        leftColumnContent={<div style={{ marginTop: '12px' }}>
            Currency
          <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
            * Required
          </div>
        </div>}
        rightColumnContent={
          <div style={{ width: '135px', position: 'relative', top: '10px', display: 'inline-block' }}>
            <Select
              name="currency"
              options={currencies}
              value={fieldValues.currency}
              onChange={({ value }) => updateFormData({ fieldName: 'currency', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location')}
              placeholder="Currency"
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div>
        }
      />
      <TwoColumnRow
        hide={Boolean(definedRateTemplate)}
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflow: 'inherit', clear: 'both', height: '54px', marginBottom: '0', marginTop: '12px' }}
        leftColumnContent={<div style={{ marginTop: '12px' }}>
            Rate template
          <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
            * Required
          </div>
        </div>}
        rightColumnContent={
          <div style={{ width: '300px', position: 'relative', top: '10px', display: 'inline-block' }}>
            <Select
              name="rateLogic"
              options={[
                { value: 'standard', label: 'Standard Rates (Adult/Child...)' },
                { value: 'multiDayTour', label: 'Multi-Day (Single/Double...)' },
                { value: 'priceBreak', label: 'Price Breaks/Per Person (From/To...)' },
                { value: 'privateTransfer', label: 'Private/Transfers (Up to...)' },
              ]}
              value={fieldValues.nonStandardTemplateType || 'standard'}
              onChange={({ value }) => updateFieldValue({ fieldName: 'nonStandardTemplateType', value })}
              placeholder="Rate template"
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div>
        }
      />
      <RatesFormTemplate
        nonStandardTemplateType={nonStandardTemplateType}
        updateFieldValue={updateFieldValue}
        updateFieldWithKeyPath={updateFieldWithKeyPath}
        {...fieldValues}
      />
    </div>
  );
};

export default NonAccomRates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-forms/non-accommo-rates-form-templates/non-accom-rates-form.jsx